export default __webpack_public_path__ + "static/media/Mask Group 25@2x.ed7d3548.png";